import {useAppDispatch} from '../../stores/configureStore'
import {createPositionFromOffset} from '../../utils/helpers/imageHelper'
import RightArrowIcon from '../icons/RightArrowIcon'
import {Img} from '../../models/editor/img'
import {IMG_REPOSITIONED} from '../../models/editor/imgHistoryItemAction'
import {
  addImageHistoryItem,
  moveImage,
  persistPosition,
} from '../../stores/editor/editor.reducer'
import {createUseStyles} from 'react-jss'
import {useTranslation} from 'react-i18next'

interface Props {
  img: Img
}

const useStyles = createUseStyles({
  controlGroup: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 10,
  },
  controlGroupHalf: {
    flexBasis: '50%',
    flexShrink: 0,
    flexGrow: 1,
  },
  groupTitle: {
    marginBottom: '10px',
    userSelect: 'none',
    fontWeight: 600,
    color: '#3f403e',
    fontFamily: 'Calibri',
    fontSize: '1.2em',
  },
  controlWrapper: {
    display: 'flex',
    flexDirection: 'row',
    maxWidth: 540,
    width: '100%',
    justifyContent: 'space-around',
  },

  iconWrapper: {
    margin: '0 10px',
  },
  icon: {
    cursor: 'pointer',
    height: '30px',
    '& path': {
      transitionDuration: '.1s',
      fill: 'var(--e-global-color-text)',
    },
    '&:hover path': {
      fill: 'var(--e-global-color-27e26ef)',
    },
  },
})

export default function MovementArrows({img}: Props) {
  const {t} = useTranslation()
  const dispatch = useAppDispatch()
  const classes = useStyles()

  return (
    <div className={`${classes.controlGroup} ${classes.controlGroupHalf}`}>
      <span className={classes.groupTitle}>{t('Mozgatás')}</span>
      <div className={classes.controlWrapper}>
        <div className={classes.iconWrapper}>
          <RightArrowIcon
            title={t('Mozgatás balra')}
            className={classes.icon}
            style={{transform: 'rotate(180deg)'}}
            onClick={() => {
              const offset = {x: -5, y: 0}
              const historyImage = {
                ...img,
                position: createPositionFromOffset(img, offset),
                origPosition: img.position,
              }
              dispatch(
                addImageHistoryItem({
                  item: {img: historyImage, action: IMG_REPOSITIONED},
                }),
              )
              dispatch(persistPosition({id: img.id}))
              dispatch(moveImage({id: img.id, offset}))
            }}
          />
        </div>
        <div className={classes.iconWrapper}>
          <RightArrowIcon
            title={t('Mozgatás jobbra')}
            className={classes.icon}
            style={{transform: 'rotate(0)'}}
            onClick={() => {
              const offset = {x: +5, y: 0}
              const historyImage = {
                ...img,
                position: createPositionFromOffset(img, offset),
                origPosition: img.position,
              }
              dispatch(
                addImageHistoryItem({
                  item: {img: historyImage, action: IMG_REPOSITIONED},
                }),
              )
              dispatch(persistPosition({id: img.id}))
              dispatch(moveImage({id: img.id, offset}))
            }}
          />
        </div>
        <div className={classes.iconWrapper}>
          <RightArrowIcon
            title={t('Mozgatás fel')}
            className={classes.icon}
            style={{transform: 'rotate(-90deg)'}}
            onClick={() => {
              const offset = {x: 0, y: -5}
              const historyImage = {
                ...img,
                position: createPositionFromOffset(img, offset),
                origPosition: img.position,
              }
              dispatch(
                addImageHistoryItem({
                  item: {img: historyImage, action: IMG_REPOSITIONED},
                }),
              )
              dispatch(persistPosition({id: img.id}))
              dispatch(moveImage({id: img.id, offset}))
            }}
          />
        </div>
        <div className={classes.iconWrapper}>
          <RightArrowIcon
            title={t('Mozgatás le')}
            className={classes.icon}
            style={{transform: 'rotate(90deg)'}}
            onClick={() => {
              const offset = {x: 0, y: +5}
              const historyImage = {
                ...img,
                position: createPositionFromOffset(img, offset),
                origPosition: img.position,
              }
              dispatch(
                addImageHistoryItem({
                  item: {img: historyImage, action: IMG_REPOSITIONED},
                }),
              )
              dispatch(persistPosition({id: img.id}))
              dispatch(moveImage({id: img.id, offset}))
            }}
          />
        </div>
      </div>
    </div>
  )
}
